<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/javascript.png" /></div>
      <p>vconsole</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/vconsole/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "3.15.1",
          linkList: [ur + "3.15.1/vconsole.min.js"]
        },
        {
          label: "3.9.5",
          linkList: [ur + "3.9.5/vconsole.min.js"]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListVconsole.vue